"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectEmbeddedInSquadsIframe = void 0;
const detectEmbeddedInSquadsIframe = () => {
    var _a, _b;
    return (typeof window !== "undefined" &&
        window.parent !== window &&
        self !== top &&
        ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.ancestorOrigins[0]) === null || _b === void 0 ? void 0 : _b.includes("squads")));
};
exports.detectEmbeddedInSquadsIframe = detectEmbeddedInSquadsIframe;
